var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlindsClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H39V42H9V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8V39H12V8H9V39V42H12H36H39V39V8H36Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.7368H44V19.4211H4V16.7368ZM4 23H44V20.3158H4V23ZM4 12.2632H44V9.57895H4V12.2632ZM4 6V8.68421H44V6H4ZM4 15.8421H44V13.1579H4V15.8421Z",
    fill: "#EE8003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 34.7368H44V37.4211H4V34.7368ZM4 30.2632H44V27.5789H4V30.2632ZM4 24V26.6842H44V24H4ZM4 33.8421H44V31.1579H4V33.8421Z",
    fill: "#EE8003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35C43 35.6 42.6 36 42 36C41.4 36 41 35.6 41 35C41 34.4 41.4 34 42 34C42.6 34 43 34.4 43 35ZM42 37C41.4 37 41 37.4 41 38C41 38.6 41.4 39 42 39C42.6 39 43 38.6 43 38C43 37.4 42.6 37 42 37ZM42 40C41.4 40 41 40.4 41 41C41 41.6 41.4 42 42 42C42.6 42 43 41.6 43 41C43 40.4 42.6 40 42 40Z",
    fill: "#9FA8DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlindsClosed);
export default __webpack_public_path__ + "static/media/blinds-closed.a2826d4b03fc9a17ff3ad8633d274fb1.svg";
export { ForwardRef as ReactComponent };